import store from "../store/index";
//------------------------
// delete combatant slots
//------------------------
export default async function useDeleteCombatantSlots(combatant_slug) {
  console.log("----------------------------");
  console.log("IN useDeleteCombatantSlots");
  return new Promise((reject) => {
    //--------------
    // access store
    //--------------
    const this_store = store;
    //--------------------
    // set api call parms
    //--------------------
    let endpoint = "api/v1/combatants/" + combatant_slug + "/deleteslots/";
    //-----------------------------
    // call delete combatant slots
    //-----------------------------
    this_store
      .dispatch("combat/deleteCombatantSlots", endpoint)
      .then(() => {})
      .catch((err) => {
        reject(err);
      });
  });
}
